module.exports = __webpack_public_path__ + "img/About_Three.d4806dc3.png";